import { useState } from "react";
import { useModal } from "../../hooks";
import { ForgotPasswordModal } from "../../pages/ForgotPasswordPage";

export const TempPasswordNotice = () => {
  const { handleModal } = useModal();
  const [sent, setSent] = useState(false);
  return (
    <div className="mb-5">
      <p>
        <strong>
          If you have ever worked with Realfoto before but haven't setup your
          password.{" "}
          <span
            className="text-link"
            onClick={() => {
              handleModal(
                <ForgotPasswordModal onSent={() => setSent(true)} />,
                {
                  centered: true,
                  id: "OrderModal",
                }
              );
            }}
          >
            Click Here.
          </span>
        </strong>
      </p>
      {sent && (
        <p>
          <strong>
            Your email is on its way. Once you have set your password you can
            log in.
          </strong>
        </p>
      )}
    </div>
  );
};
